import React from "react";
import assets from "../../../../shared/constants/assetVariables";

function FeatureFour() {
  return (
    <section className="data-management-feature-section">
      <div className="data-management-feature-container">
        <div className="data-management-feature-wrapper">
          <div className="data-management-feature-image-wrapper">
            <div className="data-management-feature-image">
              <img src={assets.images.dataTrackImage4} alt="updapt" />
            </div>
          </div>
          <div className="data-management-feature-content-wrapper">
            <div className="data-management-feature-content">
              <h2 className="data-management-feature-title">
                Validate, Trace and Audit
              </h2>
              <p className="data-management-feature-description">
                Accommodate multiple levels of data validation and create audit
                trails through a secure system to review operational workflows.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FeatureFour;
